import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { PagesListPage } from '@/features/analytics/pages/pages-list-page';

export const Route = createFileRoute('/_app/w/$workspaceId/analytics/')({
    staticData: { crumbs: [{ label: 'shell.analytics' }] },
    loader: ({ context }) => prefetch.dashboards(context.queryClient, context.workspaceScope),
    component: function AnalyticsIndexRoute() {
        const { workspaceScope } = Route.useRouteContext();
        return <PagesListPage scope={workspaceScope} />;
    },
});
